import { ArticleParagraph2 } from '@cian/ui-kit';
import * as React from 'react';
import { Link } from '../../../common/Link';
import { IBalanceProps } from '../../types';
import { PaymentStatusContainer } from '../PaymentStatus';
import { MoneySourceContainer } from '../MoneySource';

export const BalanceDesktop = (props: IBalanceProps) => {
  const { withMoneySource, showBalance, withPay, balanceString, handleDepositLinkClick } = props;

  return (
    <div>
      {withMoneySource && <MoneySourceContainer />}

      {showBalance && !!balanceString && (
        <ArticleParagraph2 as="div">
          <div data-name="balance_desktop">Баланс:&nbsp;{balanceString}</div>

          {withPay && <Link onClick={handleDepositLinkClick}>Пополнить</Link>}
        </ArticleParagraph2>
      )}

      {showBalance && !balanceString && <ArticleParagraph2>Баланс</ArticleParagraph2>}

      <PaymentStatusContainer />
    </div>
  );
};
